export enum CreditSubmissionTabs {
  General = 'general',
  Tasks = 'tasks',
  Documents = 'documents',
  Syndications = 'syndications',
  LMS = 'lms',
  Scorecard = 'scorecard',
  Proposals = 'proposals',
  Desking = 'desking',
  SubsidyCalculator = 'subsidyCalculator',
  Activity = 'activity',
}
